import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashResultsDesktopSummaryLayout({children}) {
    // Used in FlashResultsScreen to frame score summary cards

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"w-[400px] min-w-[400px] flex flex-col space-y-24"}>
            {children}
        </div>
    );
}